import Joi from 'joi';

import { DistanceUnitEnum } from '../../../../shared/enums/distance-unit.enum';

/**
 * Schema for mileage policy config validation
 */
export const mileageConfigSchema = () =>
	Joi.object({
		unlimitedMileage: Joi.boolean().optional().empty(null),
		mileageIncludedPerDay: Joi.number().min(0).allow(null).optional(),
		overageChargePerUnit: Joi.number().min(0).allow(null).optional(),
		unit: Joi.string()
			.valid(...Object.values(DistanceUnitEnum))
			.allow(null)
			.optional(),
	})
		.unknown(false)
		.custom((value, helpers) => {
			if (value.unlimitedMileage === true) {
				return value;
			}

			if (
				value.mileageIncludedPerDay == null ||
				value.overageChargePerUnit == null ||
				value.unit == null
			) {
				return helpers.error('any.custom', {
					message:
						'When mileage is not unlimited, mileageIncludedPerDay, ' +
						'overageChargePerUnit, and unit are required',
				});
			}

			return value;
		});
